/**
 * Fester nameIdentifier des Belegübersicht-Dashboards (3 Monate) im tableau-dashboard-service.
 * Wird im Belegübersicht-Widget als iframe angezeigt.
 */
export const BELEGUEBERSICHT_IDENTIFIER = 'beleguebersicht';

/**
 * Fester nameIdentifier der Belegübersicht-Detailansicht (12 Monate) im tableau-dashboard-service.
 * Wird in der Overview als interaktive Analyse geführt und aus dem Widget heraus geöffnet.
 */
export const BELEGUEBERSICHT_DETAIL_IDENTIFIER = 'beleguebersicht12Monate';
